import React, { useState } from 'react';

import LinearProgress from '@mui/material/LinearProgress';

import useWindowDimensions from '../../Hooks/useWindowDimensions';

const ProgressBar = props => {

  console.log("ProgressBar props", props);

  const { windowWidth } = useWindowDimensions();

  let activeColor = '#ED2028';
  let passiveColor = '#343333';
  let sections = [];
  let numOfQuestions = props?.count;
  const currentProgress = props?.currentProgress;
  const questionsPerSection = props?.questionsPerSection;
  const maxProgressPerSec = questionsPerSection?.map((item, idx) => questionsPerSection.slice(0, idx + 1).reduce((a, b) => a + b));
  // min progress needed in first section is always 0 
  const minProgressPerSec = [0, ...maxProgressPerSec];
  // console.log("minProgress", minProgressPerSec);

  props?.sections?.forEach((section, idx) => {
    sections.push({
      name: section.section,
      style: { color: passiveColor, fontWeight: '400' },
      questions: questionsPerSection[idx],
      progress: 0, minProgress: minProgressPerSec[idx], maxProgress: maxProgressPerSec[idx]
    })
  })

  console.log("sections", sections);

  let progressWidth = (100 / sections.length) + '%';
  if (window.innerWidth < 650) {
    progressWidth = '100%';
  }

  sections?.forEach((sec, idx) => {
    if (currentProgress >= sec.minProgress && currentProgress + 1 <= sec.maxProgress) {
      sec.progress = (((currentProgress - sec.minProgress) + 1) / sec.questions) * 100;
      sec.style = { color: activeColor, fontWeight: '700', fontSize: "21px" };
    } else {
      if ((currentProgress + 1) > (sec.maxProgress)) {
        sec.progress = 101;
      } else sec.progress = -1;
      sec.style = { color: passiveColor, fontWeight: '400', fontSize: "21px" };
    }
  })

  let progressPercentage = Math.round(((props?.currentProgress + 1) / numOfQuestions) * 100);

  // calculate percentage per section per question 
  const calcPercentPerQuestion = () => {
    let questionsPerSection = props?.questionsPerSection;
    let sections = props?.questionsPerSection?.length;
    // 100% divided by number of sections 
    let eachSection = parseFloat((100 / sections).toFixed(2));
    // console.log(eachSection);
    let progress = 0;
    let progressPerQuestionArr = [];
    for (let i = 0; i < sections; i++) {
      progress = eachSection / questionsPerSection[i];
      // console.log(progress);
      for (let j = 0; j < questionsPerSection[i]; j++) {
        progressPerQuestionArr.push(parseFloat(progress.toFixed(2)));
      }
    }

    let accumulator = 0
    progressPerQuestionArr?.forEach((value, index) => {
      if (index <= props?.currentProgress) { accumulator += value; }
      return accumulator;
    })
    // console.log("accumulator", accumulator);
    return Math.round(accumulator);
  }
  const progressPercent = calcPercentPerQuestion();
  console.log(progressPercent);


  return (
    <div>
      <p className="progress-percent-text" variant="determinate" style={{
        marginLeft: `calc(${progressPercent}% - 2ch)`
      }}>{`${progressPercentage}%`}</p>


      <div className="progress-bar">
        {sections.map((sec, index) => {
          let progress = sec.progress;
          if (progress > 100) progress = 100;
          return (
            <div className="bar-section" style={{ width: progressWidth }} key={index}>
              {/* {(sec.progress > 0 && sec.progress <= 100)?
                <img style={{marginLeft: (sec.progress - 9) + '%', transition: '1s'}}decoding="async" height="30" src="https://md1.bleat.church/wp-content/uploads/2021/05/paper-boat.png" className="attachment-full size-full" alt="" loading="lazy" />
                : <img style={{marginLeft: (sec.progress - 9) + '%', opacity: 0}}decoding="async" height="30" src="https://md1.bleat.church/wp-content/uploads/2021/05/paper-boat.png" className="attachment-full size-full" alt="" loading="lazy" />
              } */}
              <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress} /></div>
              <div className="section-title" style={sec.style}>{sec.name.toUpperCase()}</div>
            </div>
          )
        })}
      </div>
    </div>
  );
}
export default ProgressBar;



// return (
//   <div>
//     <p className="progress-percent-text" variant="determinate" style={{
//       marginLeft: `calc(${progressPercentage}% - 2ch)`
//     }}>{`${progressPercentage}%`}</p>
//     <div className="progress-bar">                
//       <div className="bar-section" style={{width: progressWidth}}>
//         <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress1} /></div>
//         <div className="section-title" style={section1style}>STRATEGY</div>
//       </div>
//       <div className="bar-section" style={{width: progressWidth}}>
//         <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress2} /></div>
//         <div className="section-title" style={section2style}>PARTNERSHIP</div>
//       </div>
//       <div className="bar-section" style={{width: progressWidth}}>
//         <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress3} /></div>
//         <div className="section-title" style={section3style}>ENGAGEMENT</div>
//       </div>
//       <div className="bar-section" style={{width: progressWidth}}>
//         <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress4} /></div>
//         <div className="section-title" style={section4style}>MISSION & VISION</div>
//       </div>
//     </div>

//   </div>
// );

